export default __webpack_public_path__ + "static/media/big-tree.04e69acf.jpeg";